import getItemsToDisplayIds from './get-items-to-display-ids';
import { OR, OR_OPERATOR, KEYWORD } from '../constants';
import buildCheckboxFilters from './build-checkbox-filters';

const buildFilterValues = (listFilterValues, relations, stringProps) => {
  const listFilterValuesKeys = Object.keys(listFilterValues);

  return listFilterValuesKeys.map(key => {
    const values = listFilterValues[key].map(el => {
      let updatedKey = key;

      const isRelation = key.includes('.');

      if (isRelation) {
        const [relationName, relationProp] = key.split('.');
        const [relation] = relations.filter(({ localField }) => localField === relationName);
        const { entityIdentifier = '' } = relation || {};
        if (entityIdentifier && entityIdentifier !== relationName)
          updatedKey = `${entityIdentifier}.${relationProp}`;
      }
      const fieldName = stringProps.includes(updatedKey) ? `${key}.${KEYWORD}` : key;
      return { match: { [fieldName]: el } };
    });
    return { bool: { should: values } };
  });
};

const buildItemsToDisplayValues = itemsToDisplay => {
  if (!itemsToDisplay || !itemsToDisplay.length) return [];
  const itemToDisplayIds = getItemsToDisplayIds(itemsToDisplay);
  return [{ ids: { values: itemToDisplayIds } }];
};

const buildShouldValues = docTypes => {
  if (Array.isArray(docTypes)) {
    return docTypes.map(docType => ({
      match: {
        docType
      }
    }));
  }
  return [
    {
      match: {
        docType: docTypes
      }
    }
  ];
};

const buildRawQueryBase = ({
  docType,
  id,
  filterValues: { checkboxFilters = [], listFilterValues = {} } = {},
  filterOperator,
  relations,
  stringProps,
  itemsToDisplay,
  addListFiltersToQuery = false
}) => {
  const listFilterFinalValues = buildFilterValues(listFilterValues, relations, stringProps);
  const checkboxFiltersValue = buildCheckboxFilters(checkboxFilters);
  const itemsToDisplayValues = buildItemsToDisplayValues(itemsToDisplay);
  const isOperatorOr = filterOperator === OR;

  const queryFilters = [];
  const baseBoolObject = {
    should: buildShouldValues(docType),
    minimum_should_match: 1,
    must: [...itemsToDisplayValues, ...checkboxFiltersValue]
  };

  if (isOperatorOr) {
    if (addListFiltersToQuery) {
      queryFilters.push(...listFilterFinalValues);
    } else {
      baseBoolObject.must.push({ bool: { [OR_OPERATOR]: [...listFilterFinalValues] } });
    }
  } else {
    baseBoolObject.must.push(...listFilterFinalValues);
  }

  const mustNot = id ? [{ ids: { values: [id] } }] : undefined;

  const queryFilter = queryFilters.length
    ? { [OR_OPERATOR]: queryFilters, minimum_should_match: 1 }
    : {};
  return {
    ...queryFilter,
    filter: {
      bool: baseBoolObject
    },
    must_not: mustNot
  };
};

export default buildRawQueryBase;
